// CSV per Excel italiano: separatore «;», BOM UTF-8 e celle protette dalle formule.
// I dati (nomi, note) li scrivono i clienti: una cella che inizia con = + - @ verrebbe eseguita da Excel.
export function csvCell(value: string | number): string {
  let text = String(value ?? "");
  const phone = /^\+[\d\s().-]{5,}$/.test(text); // +39 333 1234567: numero, non formula
  if (!phone && /^[=+\-@\t\r]/.test(text)) text = `'${text}`;
  return `"${text.replaceAll('"', '""')}"`;
}

export function csvText(rows: Array<Array<string | number>>): string {
  return "\uFEFF" + rows.map((row) => row.map(csvCell).join(";")).join("\r\n");
}

export function downloadCsv(name: string, rows: Array<Array<string | number>>) {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(new Blob([csvText(rows)], { type: "text/csv;charset=utf-8" }));
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
}
